// Vendor imports
const classNames = require('classnames')
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const PopperAnchor = require('client-v2/common/components/popper-anchor')
const collectionSelectModalSelectors = require('client-v2/common/containers/collection-select-modal/selectors')
// Sibling imports
const AddToCollectionModal = require('./modal-smart')

const DEFAULT_PLACEMENT = ['top-end', 'bottom-end']

function mapStateToProps() {
  const disabledSelector = createDisabledSelector()
  const renderPopperSelector = createRenderPopperSelector()
  return function (state, ownProps) {
    return {
      disabled: disabledSelector(state, ownProps),
      placement: ownProps.placement || DEFAULT_PLACEMENT,
      renderPopper: renderPopperSelector(ownProps)
    }
  }
}

module.exports = connect(
  mapStateToProps
)(
  PopperAnchor
)

function createDisabledSelector() {
  return createSelector(
    [
      collectionSelectModalSelectors.urlId,
      collectionSelectModalSelectors.anchorId,
      (state, ownProps) => ownProps.urlId,
      (state, ownProps) => ownProps.anchorId
    ],
    (modalUrlId, modalAnchorId, ownUrlId, ownAnchorId) => (
      modalUrlId !== ownUrlId ||
      !modalAnchorId || modalAnchorId !== ownAnchorId
    )
  )
}

function createRenderPopperSelector() {
  return createSelector(
    ownProps => ownProps.popperClassName,
    popperClassName => {
      return popperProps => (
        tag('div', {
          ref: popperProps.ref,
          className: classNames(
            popperClassName,
            'AddToCollectionModalPopper'
          ),
          style: popperProps.style
        },
          tag(AddToCollectionModal, {
            onLayoutChange: popperProps.scheduleUpdate
          })
        )
      )
    }
  )
}
